import { FormField } from '../types/ContactForm';

export const getFieldsForStep = (
    formFields: FormField[],
    stepNumber: number
): Array<{ field: FormField; originalIndex: number }> => {
    return formFields
        .map((field, index) => ({
            field,
            originalIndex: index,
            fieldStep: field.step || 1
        }))
        .filter(({ fieldStep }) => fieldStep === stepNumber)
        .map(({ field, originalIndex }) => ({ field, originalIndex }));
};


export const getFieldsCount = (formFields: FormField[], stepNumber: number): number => {
    return getFieldsForStep(formFields, stepNumber).length;
};


export const removeFieldsForStep = (
    formFields: FormField[],
    stepNumber: number
): FormField[] => {
    const updatedFields = formFields.filter(field => (field.step || 1) !== stepNumber);

    return updatedFields.map(field => {
        if (field.step && field.step > stepNumber) {
            return { ...field, step: field.step - 1 };
        }
        return field;
    });
};

